import { BACKEND_URL } from '../config'

export const getAppURL = appId => `${BACKEND_URL}/apps/${appId}`

export const getAppIdURL = query => `${BACKEND_URL}/app-search?${query}`
